import { FC } from 'react';
import { MousePointerClick, X } from 'lucide-react';

interface Props {
  title: string;
  message: string;
  onClose: () => void;
  /** Extra classes for positioning the popover relative to its anchor. */
  className?: string;
}

/**
 * Small, closable "call to attention" popover meant to sit next to a highlighted element
 * (typically paired with the reusable `.nc_pulse-attention` class). It only dismisses via
 * the X button — it never closes on outside click or hover — so callers keep full control.
 */
const AttentionOverlay: FC<Props> = ({ title, message, onClose, className }) => (
  <div className={`nc_attention-overlay${className ? ` ${className}` : ''}`} role="dialog" aria-label={title}>
    <button
      type="button"
      className="nc_attention-overlay__close"
      aria-label="Dismiss"
      onClick={event => {
        // The popover can live inside a full-card link/click target — keep the dismiss local.
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }}
    >
      <X size={16} aria-hidden />
    </button>

    <div className="nc_attention-overlay__title">
      <MousePointerClick size={16} aria-hidden />
      <span>{title}</span>
    </div>

    <p className="nc_attention-overlay__message">{message}</p>
  </div>
);

export default AttentionOverlay;
